import { render, staticRenderFns } from "./BaseSearchBottomPage.vue?vue&type=template&id=16c8d056&"
import script from "./BaseSearchBottomPage.vue?vue&type=script&lang=js&"
export * from "./BaseSearchBottomPage.vue?vue&type=script&lang=js&"
import style0 from "./BaseSearchBottomPage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/Coding/farmerspace/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VAutocomplete,VBtn,VCard,VCardText,VDialog,VFlex,VIcon,VLayout})
